import {apiback} from '../../../config';
import {Sync} from 'MWC';

export default {
    activeScreen: '',
    sendForm: async function(data) {
        const Engine = Sync.getEngine('xhr'),
            url = apiback('API_COREZOID'),
            xhr = new Engine({
                url: `${url}`,
                dataType: 'json',
                type: 'POST',
                contentType: 'application/json',
                data: {
                    conv_data: {
                        phone: data.phone,
                        product: data.product,
                        name: data.name,
                        mail: data.mail,
                        site: data.site,
                        utmMarks: data.utmMarks
                    },
                    hash: '19D3489DS33L320L'
                },
                cache: false
            });

        try {
            const response = await xhr.post();
            if (response.status !== 'ok') {
                throw new Error();
            } else {
                this.activeScreen = 'success';
            }
        } catch (error) {
            this.activeScreen = 'error';
            return error;
        }
    }
};
